import React, {useContext, useEffect, useState} from "react";
import {AuthContext} from "../context/authContext";
import Box from '@mui/material/Box';
import {DataGrid} from '@mui/x-data-grid';
import {
    approveCourt,
    getCourtSubmissions,
    onListenToCourtSubmissions,
    rejectCourt
} from "../firebase";
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import Snackbar from "@material-ui/core/Snackbar";
import {YesNoDialog} from "../components/yes-no-dialog";
import {Loader} from "../components/loader";
import {useDispatch, useSelector} from "react-redux";
import {isObjectEmpty, orderByDateDesc} from "../utils/utils";
import {getUsers} from "../ducks/user";
import Alert from "@material-ui/core/Alert/Alert";


export function CourtApprovals() {
    const [courtSubmissions, setCourtSubmissions] = useState(null);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [snackbar, setSnackbar] = useState(null);
    const handleCloseSnackbar = () => setSnackbar(null);

    const [showDialog, setShowDialog] = useState(false);
    const [dialogType, setDialogType] = useState(null);
    const [dialogData, setDialogData] = useState(null);

    const dispatch = useDispatch();
    const users = useSelector((state) => state.user.users);

    const columns = [
        {
            field: 'fullName',
            headerName: 'Full Name',
            description: 'This column has a value getter and is not sortable.',
            // sortable: false,
            width: 160,
            valueGetter: (params) =>
                `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'courtName',
            headerName: 'Court Name',
            width: 200,
            // editable: true,
        },
        {
            field: 'location',
            headerName: 'Location',
            // type: 'number',
            width: 350,
            renderCell: (params) => {
                return (<a target="_blank"
                           href={`http://maps.google.com/?q=${params.row.location}`}>{params.row.location}</a>);
            }
        },
        {
            field: 'createdAt',
            headerName: 'Created At',
            width: 250,
            // editable: true,
        },
        {
            field: 'courtData',
            headerName: 'courtData',
            width: 1,
            hide: true
        },
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            renderCell: (params) => {
                const onApprove = async (e) => {
                    e.stopPropagation(); // don't select this row after clicking

                    setShowDialog(true);
                    setDialogType('confirm');
                    setDialogData(params);

                    return null;
                };

                const onDecline = async (e) => {
                    e.stopPropagation(); // don't select this row after clicking

                    console.log('onDecline')

                    setShowDialog(true);
                    setDialogType('decline');
                    setDialogData(params);

                    return null;
                };

                return <>
                    <CheckIcon sx={{marginRight: 2}} onClick={onApprove}>Approve</CheckIcon>
                    <CancelIcon onClick={onDecline}>Cancel</CancelIcon>
                </>
            }
        }
    ];

    useEffect(() => {
        const getData = async () => {
            if (users.length == 0) {
                setIsLoading(true);

                dispatch(getUsers());
            }
        };

        getData();
    }, [dispatch]);

    useEffect(() => {
        return onListenToCourtSubmissions(async (courts) => {
            console.log('onListenToCourtSubmissions courts', courts)
            await transformData(courts);
        });
    }, []);

    useEffect(() => {
        const getData = async () => {

            if (users.length == 0) {
                return;
            }

            let courtSubmissions = await getCourtSubmissions();
            await transformData(courtSubmissions);
            setIsLoading(false);
        };

        getData();
    }, [users]);

    const transformData = async (courtSubmissions) => {

        let mergedCourtData = {};
        for (const [userId, courtInfo] of Object.entries(courtSubmissions)) {
            // console.log('courtInfo', courtInfo)

            for (const [courtId, courtData] of Object.entries(courtInfo)) {
                // console.log('courtData', courtId, courtData)

                let userInfo = users.find(user => userId == user.id)
                courtData.submittedByUser = userInfo;
                mergedCourtData[courtId] = courtData;
            }
        }

        console.log('mergedCourtData', mergedCourtData)
        setCourtSubmissions(mergedCourtData);

        let rowData = [];
        for (const [courtId, courtData] of Object.entries(mergedCourtData)) {
            let user = courtData.submittedByUser;

            if (isObjectEmpty(user)) {
                console.log('WARNING: Could not find user', user)
                continue;
            }

            let row = {
                id: courtId,
                firstName: user.firstName,
                lastName: user.lastName,
                courtName: courtData.name,
                location: courtData.formattedAddress,
                createdAt: courtData.createdAt,
                courtData: courtData,
            };

            if (courtData.hasBeenProcessed == true) {
                // ignore
            } else {
                rowData.push(row);
            }
        }

        let orderedRowData = orderByDateDesc(rowData, 'createdAt');

        setRows(orderedRowData);
    }

    const handleNo = () => {
        setShowDialog(false);
    };

    const handleYes = async () => {

        try {
            if (dialogType == 'confirm') {
                const api = dialogData.api;
                const thisRow = {};

                console.log('api', api)
                api
                    .getAllColumns()
                    .filter((c) => c.field !== "__check__" && !!c)
                    .forEach(
                        (c) => (thisRow[c.field] = dialogData.getValue(dialogData.id, c.field))
                    );

                let courtData = thisRow.courtData;
                console.log('courtData', courtData)

                await approveCourt(courtData);

                setSnackbar({children: 'Court approved', severity: 'success'});
            } else if (dialogType == 'decline') {

                const api = dialogData.api;
                const thisRow = {};

                console.log('api', api)
                api
                    .getAllColumns()
                    .filter((c) => c.field !== "__check__" && !!c)
                    .forEach(
                        (c) => (thisRow[c.field] = dialogData.getValue(dialogData.id, c.field))
                    );

                let courtData = thisRow.courtData;
                console.log('courtData', courtData)

                await rejectCourt(courtData);

                setSnackbar({children: 'Court decline', severity: 'error'});
            }

            setShowDialog(false);

        } catch (error) {
            setSnackbar({ children: "There was a server issue. Please try again later.", severity: 'error' });
        }
    };

    const renderConfirmDialog = () => {
        return (
            <YesNoDialog
                showDialog={showDialog}
                yesButtonPressed={handleYes}
                noButtonPressed={handleNo}
                dialogTitle={dialogType == 'confirm' ? 'Are you sure you want to approve this court?' : 'Are you sure you want to reject this court?'}
            />
        );
    };

    if (isLoading) {
        return (<Loader/>);
    }

    return (
        <>
            <Box height="100vh" display="flex" flexDirection="column">
                {renderConfirmDialog()}
                {!!snackbar && (<Snackbar
                    anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                    onClose={handleCloseSnackbar}
                    autoHideDuration={3000}
                    open={true}
                    key={'top' + 'center'}>
                    <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{width: '100%'}}>
                        {snackbar.children}
                    </Alert>
                </Snackbar>)}
                <DataGrid
                    sx={{
                        boxShadow: 2,
                        // border: 2,
                        // borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}
                    rows={rows}
                    columns={columns}
                    pageSize={50}
                    rowsPerPageOptions={[5]}
                    checkboxSelection
                    disableSelectionOnClick
                    experimentalFeatures={{newEditingApi: true}}
                />
            </Box>
        </>
    );
}
